import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["listButton"]

  filterItems(event) {
    event.preventDefault()
    const form = event.target.closest('form')
    const frame = document.getElementById('list_items_browser')
    frame.src = `${form.action}?${new URLSearchParams(new FormData(form))}`
  }

  selectList(event) {
    const listId = event.currentTarget.dataset.listId
    
    // Update visual selection
    this.listButtonTargets.forEach(button => {
      button.classList.toggle('bg-gray-50', button.dataset.listId === listId)
      button.classList.toggle('dark:bg-gray-700', button.dataset.listId === listId)
    })

    // Fetch list items with Turbo
    const frame = document.getElementById('list_items_browser')
    frame.src = `${window.location.pathname}?selected_list_id=${listId}`
  }
} 